import React, { useEffect } from "react";
import { motion } from "framer-motion";

const EventFormat = () => {
  useEffect(() => {
    // Load Vimeo player script
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return (
    <div className="py-20 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          {/* Vimeo Video Embed */}
          <div className="relative w-full max-w-4xl mx-auto mb-12">
            <div style={{padding:'56.25% 0 0 0', position:'relative'}}>
              <iframe 
                src="https://player.vimeo.com/video/1103881617?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;title=0&amp;byline=0&amp;portrait=0" 
                frameBorder="0" 
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                style={{position:'absolute', top:0, left:0, width:'100%', height:'100%'}} 
                title="Buildathon"
                className="rounded-lg shadow-lg"
              ></iframe>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6 text-center">
            Event Format
          </h2>

          <p className="text-gray-700 dark:text-gray-300 text-lg leading-relaxed text-left mb-12">
            The Buildathon is a multi-stage competition that challenges
            participants to rapidly prototype innovative AI solutions in one
            day. The event culminates in project presentations and prize
            distribution, with swag and networking opportunities for all
            participants. <br /> <br />
            The event will be livestreamed for those who want to follow along
            with the competition.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default EventFormat;
